export function DashboardPendingCals() {
  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-full rounded-xl p-6 w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-8'>
            <p className='font-bold text-xl text-center'>No Additional Step Required at this Time.</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>Get Ready. In a short amount of time your refund will be offically calculated.</p>
      </div>
    </div>
  )
}